import { Contraente } from './contraente';
import { TipoAltroSoggetto } from './tipo-altro-soggetto';

export class AltroSoggetto extends Contraente {
  static apiUrl: string = "altri_soggetti";


  cognome: string;
  tel: string;
  fax: string;
  cell: string;
  email: string;
  tipo: TipoAltroSoggetto;
  sdi: string;

  deserialize(input: any): AltroSoggetto {
    let retV: AltroSoggetto = new AltroSoggetto();
    retV = super.deserialize(input) as AltroSoggetto;

    if (input?.tipo) {
      retV.tipo = new TipoAltroSoggetto().deserialize(input.tipo);
    }

    return retV;
  }

  type = 'altroSoggetto';

  public getHumanIdentifier() {
    return `${this.nome ?? ''} ${this.cognome ?? ''}`
  }

}
